import { useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";

const defaultDataSelector = (slice, listKey) => {
  const items = slice?.data?.[listKey];
  return Array.isArray(items) ? items : [];
};

const defaultCountSelector = (slice, items) =>
  slice?.data?.totalNoOfRecords?.totalNoOfRecords ?? items.length;

function useEntityList({
  stateKey,
  listKey,
  actionCreators = {},
  selectExtras,
  selectData = defaultDataSelector,
  selectCount = defaultCountSelector,
}) {
  const dispatch = useDispatch();
  const slice = useSelector((state) => state?.[stateKey] || {});
  const pagination = slice?.pagination || {};
  const ui = slice?.ui || {};
  const Data = selectData(slice, listKey);
  const noOfRecords = selectCount(slice, Data, listKey);

  const actions = useMemo(
    () =>
      Object.entries(actionCreators).reduce((boundActions, [key, actionCreator]) => {
        boundActions[key] = (params) => dispatch(actionCreator(params));
        return boundActions;
      }, {}),
    [actionCreators, dispatch]
  );

  return useMemo(
    () => {
      const extras = selectExtras ? selectExtras(slice, Data) : {};

      return {
        Data,
        noOfRecords,
        rowsPerPage: pagination.rowsPerPage,
        page: pagination.page,
        loading: ui.loading,
        ...extras,
        ...actions,
      };
    },
    [
      Data,
      actions,
      noOfRecords,
      pagination.page,
      pagination.rowsPerPage,
      selectExtras,
      slice,
      ui.loading,
    ]
  );
}

export default useEntityList;
